import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { QUERY_PARAMS } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

import { DiscountLongTermStayEditPage } from "@/components/features/items/discount/item/long-term-stay/edit/ui";
import { DiscountMultiEditPage } from "@/components/features/items/discount/item/multi/edit/ui";
import { DiscountOrdinaryEditPageContainer } from "@/components/features/items/discount/item/ordinary/edit/ui";

import { useConfirmParams } from "./hooks";

export const DiscountEditPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, type, discountID } = result;

	if (type === "ordinary")
		return (
			<PageMeta
				title="通常ディスカウントの編集"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
					discountID,
				})}
			>
				<DiscountOrdinaryEditPageContainer hotelID={hotelID} discountID={discountID} />
			</PageMeta>
		);

	if (type === "long-term-stay")
		return (
			<PageMeta
				title="ディスカウントの編集"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
					discountID,
				})}
			>
				<DiscountLongTermStayEditPage hotelID={hotelID} discountID={discountID} />
			</PageMeta>
		);

	return (
		<PageMeta
			title="複合ディスカウントの編集"
			url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
				discountID,
			})}
		>
			<DiscountMultiEditPage hotelID={hotelID} discountID={discountID} />
		</PageMeta>
	);
};
